export const columns = [
  {
    header: "Status",
    accessorKey: "status",
    cell: ({ row }) => {
      const status = row.original.status;
      const statusColors = {
        open: "bg-green-100 text-green-800",
        closed: "bg-gray-100 text-gray-800",
      };
      return (
        <span
          className={`px-2 py-1 rounded-full text-xs font-medium capitalize ${
            statusColors[status] || "bg-gray-100 text-gray-800"
          }`}
        >
          {status}
        </span>
      );
    },
  },
  {
    header: "Opening Total (NPR)",
    accessorKey: "opening_total_npr",
    cell: ({ row }) => {
      const amount = row.original.opening_total_npr || 0;
      return <span>{amount.toLocaleString()}</span>;
    },
  },
  {
    header: "Closing Total (NPR)",
    accessorKey: "closing_total_npr",
    cell: ({ row }) => {
      const amount = row.original.closing_total_npr;
      return amount ? <span>{amount.toLocaleString()}</span> : <span className="text-gray-400">-</span>;
    },
  },
  {
    header: "Difference (NPR)",
    accessorKey: "difference_npr",
    cell: ({ row }) => {
      const diff = row.original.difference_npr;
      if (diff === null) return <span className="text-gray-400">-</span>;
      const color = diff >= 0 ? "text-green-600" : "text-red-600";
      return <span className={color}>{diff.toLocaleString()}</span>;
    },
  },
  {
    header: "Opened At",
    accessorKey: "opened_at",
    cell: ({ row }) => {
      const date = row.original.opened_at;
      return date ? new Date(date).toLocaleString() : "-";
    },
  },
  {
    header: "Closed At",
    accessorKey: "closed_at",
    cell: ({ row }) => {
      const date = row.original.closed_at;
      return date ? new Date(date).toLocaleString() : <span className="text-gray-400">-</span>;
    },
  },
];
